// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__zYpoL","row":"ProcedureTreatmentSummary_row__mVxGP"};